import { lazy } from "react";

import Loadable from "@/components/extended/loadable/loadable";
import { ClearanceLevel } from "@/constants/clearance-levels";
import { TableURL } from "@/constants/urls";

import { AppRouteType } from "./types";

const baseRetentionSampleRoutes: Omit<AppRouteType, "element"> = {
  name: "Retention Samples",
  pathname: TableURL.RETENTION_SAMPLES,
  type: "item",
  clearanceLevel: ClearanceLevel.ORDERS,
  children: [
    {
      name: "Edit Retention Sample",
      pathname: ":retentionSampleId",
      type: "item",
      element: Loadable(
        lazy(() => import("@/pages/edit/retention-sample/index"))
      ),
      children: [
        {
          name: "Edit Observation",
          pathname: "observations/:retentionSampleObservationId",
          type: "item",
          element: Loadable(
            lazy(() => import("@/pages/edit/retention-sample/observation"))
          ),
        },
      ],
    },
  ],
};

export const defaultRetentionSampleRoutes = {
  ...baseRetentionSampleRoutes,
  element: Loadable(lazy(() => import("@/pages/tables/retention-samples"))),
} as AppRouteType;

export const currentRetentionSampleRoutes = {
  ...baseRetentionSampleRoutes,
  element: Loadable(
    lazy(() => import("@/pages/tables/current/retention-samples"))
  ),
} as AppRouteType;
